// @flow
import React from 'react';

type Props = {
  start_time: string,
  end_time?: string,
};

export const DisplayTime = (props: Props) => {
  const { start_time, end_time } = props;

  return (
    <div className={'time-container'}>
      <h4>{start_time}</h4>
      {end_time && (
        <h4>
          <span className={'h4-font'}>&nbsp;&mdash;&nbsp;</span>
          {end_time}
        </h4>
      )}
    </div>
  );
};
